module.exports = __webpack_public_path__ + "img/green-salad.54f303dd.png";